
export default {
  name: 'BaseImage',
  props: {
    blok: {
      type: Object,
      required: true
    }
  },
  computed: {
    classes() {
      const classes = [];
      if (this.blok.background) {
        classes.push(this.blok.background);
      }
      if (this.blok.rounded) {
        classes.push('rounded');
      }
      return classes;
    }
  }
}
